export default __webpack_public_path__ + "static/content-58d0b1ddbbd5832d5e10c0bd60591f00.jpg";